export enum SyncStatus {
	NOT_SYNC = 0,
	SYNC = 1,
    RECORD_CONFLICT = 2,
}